"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formBuilder_1 = require("../../formBuilder");
function defaultEmptyVal(field) {
    return null;
}
exports.defaultEmptyVal = defaultEmptyVal;
async function defaultOptionsValidator(field) {
}
exports.defaultOptionsValidator = defaultOptionsValidator;
function formDataStrToRealValue(str, field) {
    return null;
}
exports.formDataStrToRealValue = formDataStrToRealValue;
function createGroupStartField(fieldId, title = '') {
    const field = {
        id: fieldId,
        title: '',
    };
    return Object.assign({}, field, { type: formBuilder_1.FormFieldType.GroupStart });
}
exports.createGroupStartField = createGroupStartField;
